import { render } from "./file-manager-list.vue?vue&type=template&id=10598346&scoped=true"
import script from "./file-manager-list.vue?vue&type=script&lang=js"
export * from "./file-manager-list.vue?vue&type=script&lang=js"

import "./file-manager-list.vue?vue&type=style&index=0&id=10598346&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10598346"]])

export default __exports__